import { render, staticRenderFns } from "./PotentialClient.vue?vue&type=template&id=4468107e&scoped=true"
import script from "./PotentialClient.vue?vue&type=script&lang=js"
export * from "./PotentialClient.vue?vue&type=script&lang=js"
import style0 from "./PotentialClient.vue?vue&type=style&index=0&id=4468107e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4468107e",
  null
  
)

export default component.exports